import API from './api';

// Cadence — read-only earnings-surprise API (expected vs actual EPS/revenue).
// Reads are gated server-side on trading access (superuser passes).
export const cadenceService = {
  // Coverage + verification health + recent extremes. Poll while the backfill fills.
  getSummary: () => API.get('/api/trading/earnings/summary/'),
  // One company's full quarterly surprise history + stats. 404 if the ticker is off the spine.
  getCompany: (ticker) => API.get(`/api/trading/earnings/company/${encodeURIComponent(ticker)}/`),
  // Biggest recent beats/misses across the universe.
  getLeaderboard: (params = {}) => API.get('/api/trading/earnings/leaderboard/', { params }),
  // Earnings trajectory: reported actuals + forward consensus curve + per-quarter revision drift.
  getTrajectory: (ticker, params = {}) =>
    API.get(`/api/trading/earnings/trajectory/${encodeURIComponent(ticker)}/`, { params }),
};

export default cadenceService;
